import React from 'react'

const Card = ( { icon,title, children } ) => {
    return (
        <div className="flex flex-col rounded-sm">
            <div className="bg-gray-200 flex items-center py-3 px-5">
                <div>{icon}</div>
                <div className="text-base px-5 font-bold text-black">
                    {title}
                </div>
            </div>
            <div className="grid grid-cols-1 items-center bg-white px-5 py-4">
                {children}
            </div>
        </div>
    )
}

export default Card
